/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import Select from 'react-select';

const customStyles = {
  input: (styles) => ({ ...styles, border: 'none !important' }),
  menu: (provided) => ({
    ...provided,
    maxHeight: '350px',
    overflowY: 'auto',
  }),
};

const MySect = (props) => {
  let list = [];
  if (props.dataList && typeof props.dataList.toJS === 'function') {
    list = props.dataList.toJS();
  } else {
    list = props.dataList || [];
  }
  const value = find(list, (i) => i.id === props.value) || null;
  return (
    <Select
      name={props.name}
      isMulti
      isDisabled={props.disabled}
      value={value}
      onChange={(v) => {
        if (v.length) {
          props.onChange(v[v.length - 1].id);
        } else {
          props.onChange('');
        }
      }}
      className="react-select-container"
      classNamePrefix="react-select"
      styles={customStyles}
      filterOption={(v, r) => {
        if (!r) {
          return v;
        }
        const x = v.label.toLowerCase();
        if (x.startsWith(r.toLowerCase())) {
          return v;
        }
      }}
      getOptionLabel={(option) => option.name ? option.name : option.value}
      getOptionValue={(option) => option.id}
      getNewOptionData={(myValue) => ({
        name: myValue,
        id: myValue,
      })}
      placeholder=""
      options={list}
    />
  );
};

MySect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  dataList: PropTypes.any,
  disabled: PropTypes.bool,
  name: PropTypes.string,
};

export default MySect;



// WEBPACK FOOTER //
// ./app/components/MySelect/index.js